import saveTrack from '../../../utils/gaia/saveTrack';
import {AddSavePromise} from '../../useIsSaved';
import {mapValues} from 'lodash';

export default function remove(
    action: RemoveTrackAction,
    tracks: {[trackLocalId: string]: Track},
    setTracks: React.Dispatch<React.SetStateAction<{[trackLocalId: string]: Track}>>,
    addSavePromise: AddSavePromise,
) {
    const {trackLocalId} = action;

    const prevTrack = tracks[trackLocalId];

    if (!prevTrack.isGeometryLoaded) return trackLocalId;

    const nextTrack: Track = {
        ...prevTrack,
        properties: {
            ...prevTrack.properties,
            isLocallyDeleted: true,
        },
        points: mapValues(prevTrack.points, point => ({
            ...point,
            properties: {
                ...point.properties,
                isLocallyDeleted: true,
            }
        }))
    };

    setTracks({...tracks, [trackLocalId]: nextTrack});

    if (action.save) saveTrack(nextTrack, undefined, addSavePromise);

    return trackLocalId;
}
